import type { ISEOProps } from "../types/core";

export const RegisterPageSEO: ISEOProps = {
  title: "Sign Up - Sugar Cribs",
  description:
    "Join Sugar Cribs today and start your journey as a creator or connect with amazing content creators.",
};
